import { render, staticRenderFns } from "./BaseHint.vue?vue&type=template&id=5fe5e5bf"
import script from "./BaseHint.vue?vue&type=script&lang=js"
export * from "./BaseHint.vue?vue&type=script&lang=js"
import style0 from "./BaseHint.vue?vue&type=style&index=0&id=5fe5e5bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports